exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 400px) {\n.modal-content[data-v-7041fd2b] {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n}\n.link[data-v-7041fd2b] {\n  color: #000;\n  text-decoration: underline;\n}\n.tel-input[data-v-7041fd2b] {\n  min-height: 4.5rem;\n}\n.send-sms[data-v-7041fd2b] {\n  text-decoration: underline;\n  text-align: center;\n  margin-bottom: 30px;\n  color: #11bb2e;\n  cursor: pointer;\n}\n.disabled[data-v-7041fd2b] {\n  color: gray;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n", ""]);

// exports
